var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(46.3008 46.7734) rotate(-180)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9183",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "46.3008",
              y: "46.7734",
              width: "46",
              height: "46",
              rx: "6",
              transform: "rotate(-180 46.3008 46.7734)",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9183)" } }, [
        _c("path", {
          attrs: {
            d: "M46.3008 0.773438H0.300781V46.7734H46.3008V0.773438Z",
            fill: "white",
          },
        }),
        _c("path", {
          attrs: {
            d: "M46.3008 0.773438H0.300781V23.7736C0.300781 36.476 10.5983 46.7734 23.301 46.7734C36.0033 46.7734 46.3008 36.476 46.3008 23.7736V0.773438Z",
            fill: "#D070E7",
          },
        }),
        _c("path", {
          attrs: {
            d: "M23.3021 8.44922C14.8391 8.44922 7.97852 15.3098 7.97852 23.7728C7.97852 32.2354 14.8391 39.096 23.3021 39.096C31.7646 39.096 38.6252 32.2354 38.6252 23.7728C38.6252 15.3098 31.7646 8.44922 23.3021 8.44922Z",
            fill: "#B341D7",
          },
        }),
        _c("path", {
          attrs: {
            d: "M23.3 17.4453C19.8066 17.4453 16.9746 20.2773 16.9746 23.7707C16.9746 27.2639 19.8066 30.0958 23.3 30.0958C26.7932 30.0958 29.6251 27.2639 29.6251 23.7707C29.6251 20.2773 26.7932 17.4453 23.3 17.4453Z",
            fill: "#D070E7",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }